import styled from 'styled-components';
import { media } from '../../utils';

export const Wrapper = styled.article`
	max-width: 65rem;
	margin: auto;

	h1 {
		text-align: center;
	}
`;

export const Content = styled.div`
	position: relative;
	display: grid;
	gap: var(--gap);
	align-items: center;
	max-width: 45rem;
	margin: auto;
	padding: var(--gap) 0;

	${media.medium`
		grid-template-columns: repeat(2, 1fr);
	`}
`;

export const FeaturedImg = styled.div`
	overflow: hidden;
	height: fit-content;
	background: var(--photoBg);
	padding: 0.5rem;
	position: relative;

	${media.medium`
		padding: 0.75rem;
	`}

	.gatsby-image-wrapper {
		height: auto;

		${media.small`
			height: auto;
		`}
	}

	.overlay {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}
`;

export const Description = styled.p`
	&:first-letter {
		font: normal 5rem var(--serif);
		float: left;
		margin: var(--lineHeight) var(--lineHeight) 0 0;
		line-height: 0.65;
	}

	a {
		margin-top: 1rem;
	}
`;
